import icon2 from "./icon2.png";
import icon4 from "./icon4.png";
import icon5 from "./icon5.png";
import icon6 from "./icon6.png";
import icon7 from "./icon7.png";

export const timelineData = [
  {
    date: "Oct 2024",
    text: "Registration starts",
    icon: icon4,
    position: "top",
    route: "",
  },
  {
    date: "Nov 2024",
    text: "Local round exams, all countries",
    icon: icon5,
    position: "bottom",
    route: "",
  },
  {
    date: "Jan 2025",
    text: "Opportunity round",
    icon: icon6,
    position: "top",
    route: "",
  },
  {
    date: "Mar 2025",
    text: "Announcement of results",
    icon: icon7,
    position: "bottom",
    route: "/results",
  },
  {
    date: "Apr–May 17, 2025",
    text: "Registration for global round",
    icon: icon4,
    position: "top",
    route: "/dash",
  },
  {
    date: "June 1–4",
    text: "Finals at UCLA, LA",
    icon: icon2,
    position: "bottom",
    route: "",
  },
];
